export const brandChoises = [
  { id: "TOYOTA", name: "Toyota" },
  { id: "BMW", name: "BMW" },
  { id: "JAGUAR LAND ROVER", name: "Jaguar land rover" },
  { id: "SUZUKI", name: "Suzuki" },
  { id: "STELLANTIS", name: "Stellantis" },
  { id: "MERCEDES", name: "Mercedes" },
  { id: "VOLVO", name: "Volvo" },
  { id: "TESLA", name: "Tesla" },
];
